import { AiSearch, DiscoverNavbar } from "@/features";
import { useTranslation } from "@/hooks";
import { Flex, Title } from "@mantine/core";
import { Outlet, useNavigate, useViewTransitionState } from "react-router";
import "./DiscoverLayout.css";

export function DiscoverLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isTransitioning = useViewTransitionState("/discover/search");

  async function onPrompt(prompt: string) {
    const params = new URLSearchParams();
    params.set("q", prompt);
    params.set("_limit", "10");
    params.set("_offset", "0");
    params.set("_page_no", "1");
    navigate(`/discover/search?${params.toString()}`, {
      viewTransition: true,
    });
  }

  return (
    <Flex
      direction="column"
      align="center"
      gap="xs"
      className="discover-layout"
    >
      <Flex
        direction="column"
        bg="eu_flag.9"
        w="100%"
        h={300}
        align="center"
        justify="center"
        pos="relative"
        style={{ viewTransitionName: "blue-cover" }}
      >
        <Flex
          w="100%"
          maw={600}
          direction="column"
          align="center"
          justify="center"
          gap="lg"
        >
          <Title c="white" ta="center" fw={600} fz={32}>
            {t("discover").turnCuriosityIntoInsight}
          </Title>
          <AiSearch
            width={500}
            onPrompt={onPrompt}
            placeholder={t("discover").whatAreYouCuriousAbout}
            {...(isTransitioning && { viewTransitionName: "ai-search" })}
          />
        </Flex>
      </Flex>
      <Flex
        gap={80}
        w="100%"
        maw={1200}
        px="xs"
        py={60}
        justify="space-between"
      >
        <DiscoverNavbar />
        <Outlet />
      </Flex>
    </Flex>
  );
}
